import actionCreator from '../../common/actionObjectCreator';

import submitData from '../../common/postData';
import { getUserRegion } from 'helpers/userStorage';

export const actionDescriptor = "stripePayment/";

const createAction = actionCreator(actionDescriptor);

const PROCESS_PAYMENT = createAction("PROCESS_PAYMENT");
const CLEAR_PAYMENT = createAction("CLEAR_PAYMENT");

export function processPayment({ token, portfolios, onPaymentReceived }) {
    return dispatch => {

        submitData('Payment/processStripePayment', { token, portfolios }, PROCESS_PAYMENT, dispatch, true, {}, 'POST', true, 1000, onPaymentReceived);
    }
}

export function processPaymentAnon({ token, portfolios, emailAddress, onPaymentReceived }) {
    return dispatch => {

        submitData('Payment/processStripePaymentAnon', { token, portfolios, emailAddress }, PROCESS_PAYMENT, dispatch, true, {}, 'POST', true, 1000, onPaymentReceived);
    }
}

export function processPaymentByCredits({ portfolios, onPaymentReceived }) {
    return dispatch => {

        submitData('Payment/PayByCredits', { portfolios, currency: getUserRegion() }, PROCESS_PAYMENT, dispatch, true, {}, 'POST', true, 1000, onPaymentReceived);
    }
}

export function clearPayment() {
    return {
        type: CLEAR_PAYMENT.default
    }
}

const defaultState = {
    isProcessing: false,
}

const reducer = (state = defaultState, action) => {
    var ret;

    switch (action.type) {
        case PROCESS_PAYMENT.pending:
            ret = Object.assign({}, state, { isProcessing: true, error: null });
            return ret;
        case PROCESS_PAYMENT.fulfilled:
            ret = Object.assign({}, state, { isProcessing: false, error: null });
            return ret;
        case PROCESS_PAYMENT.rejected:
            ret = Object.assign({}, state, { isProcessing: false, error: action.payload });
            return ret;
        case CLEAR_PAYMENT.default:
            // ret = Object.assign({}, state, { isProcessing: false, error: action.payload });
            return defaultState;
        default:
            return state;
    }
}

export default reducer;


// WEBPACK FOOTER //
// ./src/payments/stripe/stripe.duck.js